import { useMemo } from "react";
import { useFocusOnFeature } from "./useFocusOnFeature";
import { Feature } from "geojson";
import { MapPin } from "../components/Map";

export const useFocusOnLngLat = (
  lng?: number,
  lat?: number,
  options?: Omit<MapPin, "lng" | "lat">,
  zoom?: number
) => {
  const feature = useMemo((): Feature | undefined => {
    if (lng !== undefined && lat !== undefined)
      return {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Point",
          coordinates: [lng, lat],
        },
      };
  }, [lng, lat]);

  useFocusOnFeature(feature, zoom ? zoom: 15, options);
};
